var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isEnabledLpuClub
        ? _c(
            "div",
            {
              staticClass: "lpu-price-switcher",
              class: { "lpu-price-switcher_sticky": _vm.isSticky },
            },
            [
              _c(
                "div",
                { class: { "w-100 px-6": _vm.isSticky } },
                [
                  _vm.userClubData.isInClub
                    ? [
                        _c("ClubInfoBanner", {
                          attrs: {
                            "show-info-icon": !_vm.infoBannerLink,
                            title: "Клубная цена",
                            subtitle: "На все услуги клиники",
                            "fixed-bottom-value": _vm.switchFixedBottomValue,
                          },
                          on: {
                            "club-info-banner:click":
                              _vm.handleClubInfoBannerClick,
                          },
                        }),
                      ]
                    : [
                        !_vm.hideDetailInfoBanner
                          ? _c("ClubDetailInfoBanner", {
                              staticClass: "mb-2",
                              attrs: {
                                "fixed-bottom-value":
                                  _vm.bannerFixedBottomValue,
                                title: "Цена только для пациентов в клубе",
                                "text-button": "Продолжить",
                                subtitle: `-${_vm.discountOnServices}% на услуги в клиниках клуба и -30% на приёмы врачей.`,
                                hide: !_vm.isEnabled,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("ClubDiscountSwitch", {
                          attrs: {
                            "use-global-dispatch": "",
                            title: "Клубная цена",
                            "fixed-bottom-value": _vm.switchFixedBottomValue,
                            discount: _vm.discountOnServices,
                            enabled: _vm.isEnabled,
                          },
                          on: {
                            "club-discount-switch:click":
                              _vm.handleClubDiscountSwitchClick,
                          },
                        }),
                      ],
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEnabledLpuClub && _vm.userClubData.isInClub
        ? _c("ClubInfoModal", {
            attrs: {
              "show-club-service-price-info": "",
              "user-club-data": _vm.userClubData,
              "user-phone": _vm.userPhone,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }